import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { VendorProvider } from './contexts/VendorContext';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PendingApproval from './pages/PendingApproval';
import Dashboard from './pages/Dashboard';
import Scanner from './pages/Scanner';
import Inventory from './pages/Inventory';
import ItemDetails from './pages/ItemDetails';
import Orders from './pages/Orders';
import OrderRespond from './pages/OrderRespond';
import Profile from './pages/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminHome from './pages/admin/AdminHome';
import AdminInventory from './pages/admin/AdminInventory';
import AdminSyncLogs from './pages/admin/AdminSyncLogs';
import AdminVendors from './pages/admin/AdminVendors';
import AdminVendorOnboarding from './pages/admin/AdminVendorOnboarding';
import AdminCategories from './pages/admin/AdminCategories';

const guarded = (el: React.ReactNode) => <ProtectedRoute>{el}</ProtectedRoute>;
const admin = (el: React.ReactNode) => <AdminRoute>{el}</AdminRoute>;

function App() {
  return (
    <VendorProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
          <Route path="/orders/respond/:token" element={<OrderRespond />} />

          {/* Signed in */}
          <Route path="/pending" element={guarded(<PendingApproval />)} />
          <Route path="/dashboard" element={guarded(<Dashboard />)} />
          <Route path="/scanner" element={guarded(<Scanner />)} />
          <Route path="/inventory" element={guarded(<Inventory />)} />
          <Route path="/inventory/:id" element={guarded(<ItemDetails />)} />
          <Route path="/orders" element={guarded(<Orders />)} />
          <Route path="/profile" element={guarded(<Profile />)} />

          {/* Admin */}
          <Route path="/admin" element={admin(<AdminHome />)} />
          <Route path="/admin/inventory" element={admin(<AdminInventory />)} />
          <Route path="/admin/sync-logs" element={admin(<AdminSyncLogs />)} />
          <Route path="/admin/vendors" element={admin(<AdminVendors />)} />
          <Route path="/admin/vendors/new" element={admin(<AdminVendorOnboarding />)} />
          <Route path="/admin/vendors/:id" element={admin(<AdminVendorOnboarding />)} />
          <Route path="/admin/categories" element={admin(<AdminCategories />)} />
          <Route path="/admin/orders" element={admin(<Orders adminView />)} />

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </VendorProvider>
  );
}

export default App;
